export default "__VITE_ASSET__Dhm$8SY3__"